const kr = {
    common: {
        history: "역사적인 버전"
    }
};
export default kr;



// WEBPACK FOOTER //
// ./src/i18n/langs/kr.js